module.exports = __webpack_public_path__ + "img/vf6.d3bd8fe4.png";